import {
  ECOM_ENTITY_TYPES,
  ECOM_WEBSTORE_SECTION_BOUND_TYPE,
  ECOM_WEBSTORE_SECTION_TYPE_ENUM,
  INPUT_CONTROL_TYPE_ENUM
} from '../../../config/constants';
import { ECOM_WEBSTORE_SECTIONS } from './sections/wsSectionConfig';

const VIEW_SCREEN_RATIO_ENUM = {
  desktop: 'desktop',
  mobile: 'mobile',
  fullscreen: 'fullscreen'
};

const SIDEBAR_VIEW_ENUM = {
  template: 'template',
  settings: 'settings'
};

const WEBSTORE_SETTING_TYPE_ENUM = {
  LOGO: 'LOGO',
  COLORS: 'COLORS',
  TYPOGRAPHY: 'TYPOGRAPHY',
  LAYOUT: 'LAYOUT',
  PRODUCTS: 'PRODUCTS',
  CHECKOUT: 'CHECKOUT',
  SOCIAL_SHARE: 'SOCIAL_SHARE'
};

const configNameValues = {
  desktopLogoWidth: 'desktopLogoWidth',
  headingFontType: 'headingFontType',
  headingFontSizeScale: 'headingFontSizeScale',
  bodyFontType: 'bodyFontType',
  bodyFontSizeScale: 'bodyFontSizeScale',
  pageWidth: 'pageWidth',
  spaceBetweenBodySections: 'spaceBetweenBodySections',

  // PRODUCTS
  hideAllProductBadges: 'hideAllProductBadges',
  hideFreeShippingBadge: 'hideFreeShippingBadge',

  // CHECKOUT
  pickupInsteadOfShipping: 'pickupInsteadOfShipping',
  makeFundraiserInputRequired: 'makeFundraiserInputRequired',
  enableCustomFundraiser: 'enableCustomFundraiser',

  // SOCIAL SHARE
  facebookEnabled: 'facebookEnabled',
  xEnabled: 'xEnabled',
  pinterestEnabled: 'pinterestEnabled',
  linkedinEnabled: 'linkedinEnabled',
  emailEnabled: 'emailEnabled',
  whatsappEnabled: 'whatsappEnabled',
  redditEnabled: 'redditEnabled',
  tumblrEnabled: 'tumblrEnabled',
  telegramEnabled: 'telegramEnabled',
  socialShareImage: 'socialShareImage'
};

const configDefaultValues = {
  [configNameValues.desktopLogoWidth]: '150',
  [configNameValues.headingFontType]: 'Arial',
  [configNameValues.headingFontSizeScale]: '100',
  [configNameValues.bodyFontType]: 'Arial',
  [configNameValues.bodyFontSizeScale]: '100',
  [configNameValues.pageWidth]: '1200',
  [configNameValues.spaceBetweenBodySections]: '0',

  // PRODUCTS
  [configNameValues.hideAllProductBadges]: 'false',
  [configNameValues.hideFreeShippingBadge]: 'false',

  // CHECKOUT
  [configNameValues.pickupInsteadOfShipping]: 'false',
  [configNameValues.makeFundraiserInputRequired]: 'false',
  [configNameValues.enableCustomFundraiser]: 'false',

  // SOCIAL SHARE
  [configNameValues.facebookEnabled]: 'true',
  [configNameValues.xEnabled]: 'true',
  [configNameValues.linkedinEnabled]: 'true',
  [configNameValues.pinterestEnabled]: 'false',
  [configNameValues.emailEnabled]: 'false',
  [configNameValues.whatsappEnabled]: 'false',
  [configNameValues.redditEnabled]: 'false',
  [configNameValues.tumblrEnabled]: 'false',
  [configNameValues.telegramEnabled]: 'false',
  [configNameValues.socialShareImage]: ''
};

const configSections = {
  [WEBSTORE_SETTING_TYPE_ENUM.LOGO]: {
    value: WEBSTORE_SETTING_TYPE_ENUM.LOGO,
    title: 'Logo',
    configOptions: {
      [configNameValues.desktopLogoWidth]: {
        label: 'Desktop logo width',
        type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
        min: 50,
        max: 300,
        unit: 'px',
        isVisible: (configValues, themeConfig) => !!themeConfig.logoImageUrl
      }
    }
  },
  [WEBSTORE_SETTING_TYPE_ENUM.COLORS]: {
    value: WEBSTORE_SETTING_TYPE_ENUM.COLORS,
    title: 'Colors',
    configOptions: {}
  },
  // [WEBSTORE_SETTING_TYPE_ENUM.TYPOGRAPHY]: {
  //   value: WEBSTORE_SETTING_TYPE_ENUM.TYPOGRAPHY,
  //   title: 'Typography',
  //   configOptions: {
  //     [configNameValues.headingFontType]: {
  //       label: 'Heading font',
  //       type: INPUT_CONTROL_TYPE_ENUM.DROP_DOWN,
  //       options: [
  //         { value: 'Arial', label: 'Arial' },
  //         { value: 'Roboto', label: 'Roboto' },
  //         { value: 'Open Sans', label: 'Open Sans' }
  //       ]
  //     },
  //     [configNameValues.headingFontSizeScale]: {
  //       label: 'Font size scale',
  //       type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
  //       min: 100,
  //       max: 150,
  //       unit: '%'
  //     },
  //     [configNameValues.bodyFontType]: {
  //       label: 'Body font',
  //       type: INPUT_CONTROL_TYPE_ENUM.DROP_DOWN,
  //       options: [
  //         { value: 'Arial', label: 'Arial' },
  //         { value: 'Roboto', label: 'Roboto' },
  //         { value: 'Open Sans', label: 'Open Sans' }
  //       ]
  //     },
  //     [configNameValues.bodyFontSizeScale]: {
  //       label: 'Font size scale',
  //       type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
  //       min: 100,
  //       max: 150,
  //       unit: '%'
  //     }
  //   }
  // },
  [WEBSTORE_SETTING_TYPE_ENUM.LAYOUT]: {
    value: WEBSTORE_SETTING_TYPE_ENUM.LAYOUT,
    title: 'Layout',
    configOptions: {
      [configNameValues.pageWidth]: {
        label: 'Page width',
        type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
        min: 1000,
        max: 2600,
        unit: 'px'
      },
      [configNameValues.spaceBetweenBodySections]: {
        label: 'Space between body sections',
        type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
        min: 0,
        max: 100,
        unit: 'px'
      }
    }
  },
  [WEBSTORE_SETTING_TYPE_ENUM.PRODUCTS]: {
    value: WEBSTORE_SETTING_TYPE_ENUM.PRODUCTS,
    title: 'Products',
    configOptions: {
      [configNameValues.hideAllProductBadges]: {
        label: 'Hide all badges',
        description:
          'Disable all product badges from appearing on the product image.',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.hideFreeShippingBadge]: {
        label: 'Hide free shipping badge',
        description: 'Remove the free shipping badge from the product image.',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      }
    }
  },
  [WEBSTORE_SETTING_TYPE_ENUM.CHECKOUT]: {
    value: WEBSTORE_SETTING_TYPE_ENUM.CHECKOUT,
    title: 'Checkout',
    configOptions: {
      [configNameValues.pickupInsteadOfShipping]: {
        label: 'Pickup instead of shipping',
        description:
          'Display your products as "Pickup Only" instead of offering free shipping. For any items still eligible for shipping, the regular shipping cost will be shown.',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.makeFundraiserInputRequired]: {
        label: 'Make fundraiser input required',
        isAdminOnly: true,
        description:
          'Make the fundraiser input mandatory at checkout. Additionally, ensure that fundraiser players are added to the store to enable this feature; otherwise, the input will remain hidden.',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.enableCustomFundraiser]: {
        label: 'Enable custom fundraiser input',
        isAdminOnly: true,
        description:
          'Allow customers to enter a custom player or team name during checkout by enabling an additional custom entry input for the fundraiser.',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      }
    }
  },
  [WEBSTORE_SETTING_TYPE_ENUM.SOCIAL_SHARE]: {
    value: WEBSTORE_SETTING_TYPE_ENUM.SOCIAL_SHARE,
    title: 'Social sharing',
    configOptions: {
      [configNameValues.socialShareImage]: {
        label: 'Share image',
        description:
          'This image will be used when sharing to Pinterest. If no image is selected, the store logo will be used instead.',
        type: 'entity',
        entityType: ECOM_ENTITY_TYPES.ecomStoreMedia,
        isVisible: (config) => config.pinterestEnabled === 'true'
      },
      [configNameValues.facebookEnabled]: {
        label: 'Enable Facebook',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.xEnabled]: {
        label: 'Enable X',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.pinterestEnabled]: {
        label: 'Enable Pinterest',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.linkedinEnabled]: {
        label: 'Enable LinkedIn',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.emailEnabled]: {
        label: 'Enable Email',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.whatsappEnabled]: {
        label: 'Enable WhatsApp',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.redditEnabled]: {
        label: 'Enable Reddit',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.tumblrEnabled]: {
        label: 'Enable Tumblr',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      },
      [configNameValues.telegramEnabled]: {
        label: 'Enable Telegram',
        type: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
      }
    }
  }
};

const config = {
  configSections,
  requiredSections: [
    {
      config: ECOM_WEBSTORE_SECTIONS[ECOM_WEBSTORE_SECTION_TYPE_ENUM.HEADER],
      location: ECOM_WEBSTORE_SECTION_BOUND_TYPE.HEADER
    },
    {
      config: ECOM_WEBSTORE_SECTIONS[ECOM_WEBSTORE_SECTION_TYPE_ENUM.FOOTER],
      location: ECOM_WEBSTORE_SECTION_BOUND_TYPE.FOOTER
    }
  ],
  defaultConfig: configDefaultValues
};

export {
  config,
  configSections,
  configNameValues,
  configDefaultValues,
  VIEW_SCREEN_RATIO_ENUM,
  SIDEBAR_VIEW_ENUM,
  WEBSTORE_SETTING_TYPE_ENUM
};
